import { BlockVisualization } from 'webapp/enums/enums';

import VisualizationFunnel from 'webapp/models-custom/visualization/funnel';

export default class VisualizationPipeline extends VisualizationFunnel {
	override visualizationType = BlockVisualization.PIPELINE;
}
